import { apiRequest } from 'utils/request'

export const fetchFeatureSnapshots = ({ featureId }) => {
  const uri = `/features/${featureId}/snapshots`
  return apiRequest({ uri })
}
